module.exports = {"id":"226215","name":"Sabin Merino","rating":"75","photo":"./data/images/photos/3/226215.png","club":{"name":"Athletic Bilbao","logo":"./data/images/clubs/AthleticBilbao.png"},"positions":["AG","BU","AD","MG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SabinMerino0.json
// module id = 3768
// module chunks = 0